import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";
import DecryptToken from "../../../utils/secure/DecryptToken";
import FetchData from "../../../services/FetchData";
import PostData from "../../../services/PostData";
import axios from "axios";

export default function Profile() {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const token = localStorage.getItem("access_token");
  const UID = jwtDecode(token)?.data.id;
  const toast = useToast();

  const [error, setError] = useState("");

  const { data } = FetchData({
    url: "/users/" + UID,
  });

  const [profileData, setProfileData] = useState();

  useEffect(() => {
    if (data === null) return;
    setProfileData({
      company: data?.company,
      phone: data?.phone,
      address: data?.address,
      email: data?.email,
      pic_name: data?.pic_name,
      pic_phone: data?.pic_phone,
    });
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfileData({ ...profileData, [name]: value });
  };

  const handleSave = () => {
    console.log(profileData);

    axios
      .put(baseURL + "/users/" + UID, profileData, {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          toast({
            title: "Data Berhasil Disimpan",
            description: "Perubahan Data Pada Profile Berhasil Disimpan",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
        }
      })
      .catch((e) => {
        if (e.response.status === 403) {
          console.log(e);
          setError(e.response.data.error.message);
        }
      });
  };

  return (
    <Stack spacing={5} py="3">
      <FormControl>
        <FormLabel>PIC Nama</FormLabel>
        <Input
          type="text"
          name="pic_name"
          onChange={handleChange}
          value={profileData?.pic_name}
        />
      </FormControl>
      <FormControl>
        <FormLabel>Email </FormLabel>
        <Input
          type="email"
          name="email"
          onChange={handleChange}
          value={profileData?.email}
        />
      </FormControl>
      <FormControl>
        <FormLabel>No. Telephone</FormLabel>
        <Input
          name="pic_phone"
          type="text"
          onChange={handleChange}
          value={profileData?.pic_phone}
        />
      </FormControl>
      {error && <Text color="red">{error} </Text>}
      <Box>
        <Button
          disabled={
            profileData?.pic_name === "" ||
            profileData?.email === "" ||
            profileData?.pic_phone === ""
          }
          px="10"
          colorScheme="blue"
          onClick={handleSave}
        >
          Simpan
        </Button>
      </Box>
    </Stack>
  );
}
